module.exports = __webpack_public_path__ + "static/12x12-nephrite-jade-tile-backlit-24ddd47220abfcc227a2b5731e937a46.jpg";